import UIMultiColumn from 'UIComponents/layout/UIMultiColumn';
import UIMultiColumnGroup from 'UIComponents/layout/UIMultiColumnGroup';
import UIMultiColumnItem from 'UIComponents/layout/UIMultiColumnItem';
import UIToggle from 'UIComponents/input/UIToggle';
import UIFormLabel from 'UIComponents/form/UIFormLabel';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Toggle = ({
  id = '',
  label = '',
  value = false,
  disabled = false,
  disabledTooltipTitle = '',
  onChange = () => {},
  readOnly = false
}) => /*#__PURE__*/_jsx(UIMultiColumn, {
  flush: true,
  style: {
    background: 'none'
  },
  children: /*#__PURE__*/_jsxs(UIMultiColumnGroup, {
    children: [/*#__PURE__*/_jsx(UIMultiColumnItem, {
      children: /*#__PURE__*/_jsx(UIFormLabel, {
        htmlFor: id,
        children: label
      })
    }), /*#__PURE__*/_jsx(UIMultiColumnItem, {
      width: "80px",
      children: /*#__PURE__*/_jsx(UITooltip, {
        title: disabledTooltipTitle,
        disabled: !disabled || !disabledTooltipTitle,
        children: /*#__PURE__*/_jsx(UIToggle, {
          "data-selenium": `form-${id}`,
          "data-checked": Boolean(value),
          id: id,
          size: "small",
          checked: Boolean(value),
          onChange: onChange,
          disabled: disabled,
          readOnly: readOnly
        })
      })
    })]
  })
});
export default Toggle;